import { Markdown } from '@/components/ui/markdown'
import { useTypingEffect } from '@/hooks/use-typing-effect'

type MarkdownWithTypingEffectProps = Readonly<{
  markdown: string
  enableTypingAnimation?: boolean
  renderOnTypingComplete?: () => React.ReactNode
}>

export const MarkdownWithTypingEffect = ({
  markdown,
  enableTypingAnimation,
  renderOnTypingComplete,
}: MarkdownWithTypingEffectProps) => {
  const { displayedText, isTyping } = useTypingEffect(markdown, {
    isAnimating: enableTypingAnimation,
  })

  return (
    <div className='flex w-full flex-col gap-4'>
      <Markdown>{displayedText}</Markdown>
      {!isTyping && renderOnTypingComplete?.()}
    </div>
  )
}
